
import processDateAvailable from "~/mixin/process-date-available-mixin";
import OccasionsMixin from "~/mixin/occasions-fetch-mixin";
import processLineitemsMixin from "@/mixin/process-lineitems-mixin";
import { getDateSuffix } from "@/utils/locale";

export default {
  name: "cal-ongoing-frequency",
  mixins: [processDateAvailable, OccasionsMixin, processLineitemsMixin],
  props: {
    maxQuantity: {
      type: Number,
      default: 8,
    },
    minQuantity: {
      type: Number,
      default: 1,
    },
    subscriptionTimePeriod: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      cutoffs: [],
      activeIndex: [],
      weekFrequency: 0,
      selectedDate: "",
      nextAvailableDate: this.$dayjs().format("YYYY-MM-DD"),
      maxDate: "",
      product: { ...this.$store.state.cartItem.product },
      deliveryDates: { ...this.$store.state.cartItem.subsDeliveryDates },
      validationFailed: false,
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      datesUpdated: null,
      selectedFrequency: this.$store.state.cartItem.frequency || 0,
      currentLocale: this.$i18n.getLocaleCookie(),
      occasions: [],
      cutoffCountdown: [],
      localSubscriptionTimePeriod: this.$store.state.cartItem.subscriptionTimePeriod > 0 ?
        this.$store.state.cartItem.subscriptionTimePeriod : this.minQuantity
    };
  },
  computed: {
    subscriptionTimePeriodSelected() {
      return (
        this.localSubscriptionTimePeriod ||
        this.$store.state.cartItem.subscriptionTimePeriod
      );
    },
    dates() {
      let dt =
        this.datesUpdated || this.$store.state.cartItem.subscriptionDates;
      if (dt.length > 0 && dt.length !== this.subscriptionTimePeriodSelected) {
        dt = dt.slice(this.subscriptionTimePeriodSelected);
      }
      return dt;
    },
    productSubTotal() {
      return `$${
        this.product.price *
        (this.localSubscriptionTimePeriod ||
          this.$store.state.cartItem.subscriptionTimePeriod)
      }`;
    },
  },
  watch: {
    localSubscriptionTimePeriod() {
      this.onInit();
    },
  },
  beforeUpdated() {
    this.initDeliveryDates();
  },
  updated() {
    this.product = { ...this.$store.state.cartItem.product };
    this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };
    this.selectedFrequency = this.$store.state.cartItem.frequency || 0;
    this.localSubscriptionTimePeriod =
      this.$store.state.cartItem.subscriptionTimePeriod > 0
        ? this.$store.state.cartItem.subscriptionTimePeriod
        : this.minQuantity;
  },
  async created() {
    this.onInit();
    this.maxDate = this.$dayjs().add(1, "year").format("YYYY-MM-DD");
    this.occasions = await this.getOccasions();
    this.setSubData();

    this.$nuxt.$on("updatedSubSize", () => {
      this.product = { ...this.$store.state.cartItem.product };
      this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };
      this.selectedFrequency = this.$store.state.cartItem.frequency || 0;
      this.localSubscriptionTimePeriod =
        this.$store.state.cartItem.subscriptionTimePeriod > 0
          ? this.$store.state.cartItem.subscriptionTimePeriod
          : this.minQuantity;
      this.setSubData();
      this.initDeliveryDates();
      this.$nuxt.$on("scrollToOngoingFrequency", () => {
        const ongoingFrequencyEl = document.getElementById("ongoing-frequency");
        if (ongoingFrequencyEl) {
          ongoingFrequencyEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    });
  },
  methods: {
    setSubData() {
      if (
        this.$store.state.cartItem.subscriptionProd.variants.length > 0 &&
        this.$store.state.cartItem.selectedSubscription.variantType.length > 0
      ) {
        let mappedVariant =
          this.$store.state.cartItem.subscriptionProd.variants.find(
            (variant) =>
              variant.displayTitle.includes(
                this.$store.state.cartItem.selectedSubscription.variantType
              ) &&
              variant.displayTitle.includes(
                this.$store.state.cartItem.selectedSubscription.collectionType
              )
          );

        this.$store.dispatch("cartItem/PRODUCT_SET", {
          product: {
            ...mappedVariant,
            sellingPlans: this.product.sellingPlans,
          },
          locale: this.$store.state.cartItem.locale,
          deliveryTown: this.$store.state.cartItem.deliveryTown,
          id: this.$store.state.cartItem.id,
        });
        if (
          !(
            this.$store.state.cartItem.product &&
            this.$store.state.cartItem.product.selectedSellingPlan &&
            this.$store.state.cartItem.product.selectedSellingPlan.length > 0
          )
        ) {
          this.setSellingPlan();
        }
      }
    },
    decrementQuantity(event) {
      event.stopPropagation();
      if (this.localSubscriptionTimePeriod > 0) {
        this.localSubscriptionTimePeriod--;
        this.setSellingPlan();
      }
    },
    incrementQuantity(event) {
      event.stopPropagation();
      if (this.localSubscriptionTimePeriod < this.maxQuantity) {
        this.localSubscriptionTimePeriod++;
        this.setSellingPlan();
      }
    },
    setSellingPlan() {
      if (this.product.sellingPlans && this.product.sellingPlans.length > 0)
        this.$store.dispatch(
          "cartItem/SET_SELLING_PLAN",
          this.product.sellingPlans[this.localSubscriptionTimePeriod - 1]
        );
    },
    updateQuantity(value) {
      const regex = /^\d+$/;

      if (!value.match(regex) || value === "") {
        this.localSubscriptionTimePeriod = this.minQuantity;
        return;
      }

      const num = parseInt(value);

      if (num > this.maxQuantity) {
        this.localSubscriptionTimePeriod = this.maxQuantity;
      } else if (num < 0) {
        this.localSubscriptionTimePeriod = this.minQuantity;
      } else {
        this.localSubscriptionTimePeriod = num;
      }
      this.frequncyUpdate();
      this.$forceUpdate();
    },
    frequncyUpdate() {
      const selectedFrequency = this.localSubscriptionTimePeriod;
      const dates = [...this.dates];
      for (let i = 1; i < this.subscriptionTimePeriodSelected; i++) {
        let dateObj = new Object();
        dateObj["actualDate"] =
          i === 0
            ? this.$store.state.cartItem.deliveryDate
            : this.$dayjs(dates[i - 1]["actualDate"])
                .add(7 * selectedFrequency, "day")
                .format("YYYY-MM-DD");

        while (this.unavailableDates.includes(dateObj["actualDate"])) {
          dateObj["actualDate"] = this.$dayjs(dateObj["actualDate"])
            .add(1, "day")
            .format("YYYY-MM-DD");
        }

        dateObj["startDate"] =
          i === 0
            ? this.$dayjs().format("YYYY-MM-DD")
            : this.$dayjs(dates[i - 1]["actualDate"])
                .add(1, "day")
                .format("YYYY-MM-DD");

        i > 0
          ? (this.deliveryDates[`DELIVERY_DATE-${i + 1}`] =
              dateObj["actualDate"])
          : (this.deliveryDates["DELIVERY_DATE"] = dateObj["actualDate"]);
        dates[i] = { ...dateObj };
      }

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dates);

      this.$store.dispatch("cartItem/SUBS_DELIVERY_DATES_ADD", {
        ...this.deliveryDates,
      });
      this.$store.dispatch("cartItem/SUBS_FREQUENCY_SET", selectedFrequency);
    },
    validateWithMaxDate(date) {
      return this.$dayjs(this.maxDate).diff(this.$dayjs(date)) > 0;
    },
    onInit() {
      if (this.localSubscriptionTimePeriod) {
        this.$store.dispatch(
          "cartItem/SUBS_TIME_PERIOD_SET",
          this.localSubscriptionTimePeriod
        );
        this.$store.dispatch(
          "cartItem/SUBS_FREQUENCY_SET",
          this.localSubscriptionTimePeriod
        );
        this.$nuxt.$emit("ongoingFrequencyDisabled", false);
      }

      if (JSON.stringify(this.deliveryDates) !== "{}") {
        this.$nuxt.$emit("ongoingFrequencyDisabled", false);
      }

      this.selectedFrequency = 0;

      this.initDeliveryDates();
    },
    calanderExpansion(index) {
      if (this.activeIndex.indexOf(index) > -1) {
        this.activeIndex.splice(this.activeIndex.indexOf(index), 1);
      } else {
        this.activeIndex.push(index);
      }
    },
    getDateSuffix(index) {
      return getDateSuffix(this.$i18n.locale, index, false);
    },
    copyDatesFromStore() {
      const dates = [];
      for (const item of this.dates) {
        dates.push({ ...item });
      }
      return dates;
    },
    updateCalanderDates(selectedDate, index) {
      this.validationFailed = false;
      this.nextAvailableDate = selectedDate;
      const dateObj = this.copyDatesFromStore();
      dateObj[index]["actualDate"] = selectedDate;
      if (index === 0) {
        this.$store.dispatch("cartItem/UPDATE_DELIVERY_DATE", selectedDate);
      }
      this.selectedFrequency = 0;

      for (let i = index; i < this.subscriptionTimePeriodSelected; i++) {
        if (i === index) {
          dateObj[i]["actualDate"] = selectedDate;
        } else {
          dateObj[i]["actualDate"] = "";
          dateObj[i]["startDate"] = this.$dayjs(
            dateObj[i - 1]["actualDate"] === ""
              ? dateObj[i - 1]["startDate"]
              : dateObj[i - 1]["actualDate"]
          )
            .add(1, "day")
            .format("YYYY-MM-DD");
        }

        i > 0 && i < this.subscriptionTimePeriodSelected
          ? (this.deliveryDates[`DELIVERY_DATE-${i + 1}`] =
              dateObj[i]["actualDate"])
          : (this.deliveryDates["DELIVERY_DATE"] = dateObj[0]["actualDate"]);

        if (this.deliveryDates.length !== this.subscriptionTimePeriodSelected) {
          this.deliveryDates = Object.fromEntries(
            Object.entries(this.deliveryDates).slice(
              0,
              this.subscriptionTimePeriodSelected
            )
          );
        }
      }

      this.$nuxt.$emit("ongoingFrequencyDisabled", false);
      this.$store.dispatch("cartItem/SUBS_DELIVERY_DATES_ADD", {
        ...this.deliveryDates,
      });

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dateObj);
      this.calanderExpansion(index);
    },
    checkActualDateIsSet(dates, index) {
      return dates[index] && dates[index]["actualDate"];
    },
    initDeliveryDates() {
      this.$nuxt.$emit("ongoingFrequencyDisabled", false); // make it false due ti a issue in subs edit TODO: need perment fix
      this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };
      let dates = [...this.dates];

      for (let i = 0; i < this.subscriptionTimePeriodSelected; i++) {
        let dateObj = new Object();

        if (i == 0) {
          dateObj["startDate"] = this.$dayjs().format("YYYY-MM-DD");
          dateObj["actualDate"] = this.$store.state.cartItem.deliveryDate;
          dates[i] = { ...dateObj };
        }

        if (this.checkActualDateIsSet(dates, i)) {
          continue;
        }

        if (i > 0) {
          dateObj["startDate"] = this.$dayjs(
            dates[i - 1]["actualDate"] === "" || !dates[i - 1]["actualDate"]
              ? dates[i - 1]["startDate"]
              : dates[i - 1]["actualDate"]
          )
            .add(1, "day")
            .format("YYYY-MM-DD");
          this.$store.state.cartItem.subscriptionDates[i]
            ? (dateObj["actualDate"] =
                this.$store.state.cartItem.subscriptionDates[i]["actualDate"])
            : (dateObj["actualDate"] = "");
        } else {
          dateObj["startDate"] = this.$dayjs().format("YYYY-MM-DD");
          dateObj["actualDate"] = this.$store.state.cartItem.deliveryDate;
        }
        dates[i] = { ...dateObj };

        i > 0
          ? (this.deliveryDates[`DELIVERY_DATE-${i + 1}`] =
              dateObj["actualDate"])
          : (this.deliveryDates[`DELIVERY_DATE`] =
              this.$store.state.cartItem.deliveryDate);
      }

      if (this.deliveryDates.length !== this.subscriptionTimePeriodSelected) {
        this.deliveryDates = Object.fromEntries(
          Object.entries(this.deliveryDates).slice(
            0,
            this.subscriptionTimePeriodSelected
          )
        );
      }

      this.$store.dispatch("cartItem/SUBS_DELIVERY_DATES_ADD", {
        ...this.deliveryDates,
      });

      if (!this.checkActualDateIsSet(dates, 0)) {
        dates[0]["actualDate"] = this.$store.state.cartItem.deliveryDate;
      }

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dates);
    },
    async getCutoff() {
      try {
        this.cutoffs = await this.$axios.$get(
          `v3/region/cutoff/${JSON.parse(
            sessionStorage.deliveryTown
          ).regionTag.toLowerCase()}`,
          {
            headers: {
              "callia-lang": this.$i18n.locale,
            },
          }
        );
        this.closedDays = this.cutoffs.closedDates.map((closeD) =>
          parseInt(closeD)
        );
        const cutoffDateResponse = this.processDateRestrictions(this.cutoffs);
        this.nextAvailableDate = this.findNextAvailableDate(
          this.$dayjs().format(),
          {
            ...cutoffDateResponse,
            finalCloseDays: this.closedDays,
          }
        ).format("YYYY-MM-DD");
        this.closedDays = this.closedDays;
        this.unavailableDates = cutoffDateResponse.finalUnavailableDates;
        this.availableDates = cutoffDateResponse.finalAvailableDates;
        this.cutoffCountdown = this.cutoffs.cutoff_countdown;
      } catch (error) {
        console.error(error);
      }
    },
    async fetch() {
      await this.getCutoff();
    },
  },
};
